import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapGetters, mapState } from "vuex";
import Amplitude from "@Shared/@Utils/amplitude";
import SessionIntervalsMixin from "@Shared/@Utils/shared-mixins/session/session-intervals-mixin";
import { CURRENT_ACCOUNT_DETAILS, CURRENT_USER_DETAILS, EMAIL_VERIFIED } from "../store/account/account-getters";
import EmailVerificationBanner from "@Client/@Modules/banners/email-verification-banner.vue";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "AuthApp",
  components: {
    EmailVerificationBanner
  },
  mixins: [SessionIntervalsMixin],
  props: {
    routeRedirectName: {
      type: String,
      default: "login"
    }
  },
  data() {
    return {
      showingSidebar: true
    };
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState("AccountStore", ["token"])), mapGetters("AccountStore", [CURRENT_USER_DETAILS, CURRENT_ACCOUNT_DETAILS, EMAIL_VERIFIED])), {}, {
    addWidgetClass() {
      return this.routeRedirectName === "welcome-page";
    },
    isSideBarVisible() {
      return this.showingSidebar && this.currentPage !== "subdomain-interstitial";
    },
    currentPage() {
      return this.$route.name;
    }
  }),
  watch: {
    token: {
      immediate: true,
      handler(val) {
        if (!val) {
          this.$router.replace({
            name: this.routeRedirectName
          });
        }
      }
    }
  },
  async beforeMount() {
    Amplitude.updateVisits();
  },
  methods: {
    handleToggle({
      value
    }) {
      this.showingSidebar = value;
    }
  }
});